export default "__VITE_ASSET__6xMhM5vW__"